// src/components/Image/ImageList.tsx
import React from "react";
import { DndContext, closestCenter, DragEndEvent } from "@dnd-kit/core";
import { SortableContext, arrayMove, verticalListSortingStrategy } from "@dnd-kit/sortable";
import ImagePreview from "./ImagePreview";
import { ImageListProps } from "../../types/screensTypes";

const ImageList: React.FC<ImageListProps> = ({ pictures, setPictures }) => {
    const handleDragEnd = (event: DragEndEvent): void => {
        const { active, over } = event;
        if (!over || active.id === over.id) return;

        const oldIndex = pictures.findIndex((photo) => photo === active.id);
        const newIndex = pictures.findIndex((photo) => photo === over.id);

        const reorderedPictures = arrayMove(pictures, oldIndex, newIndex);
        setPictures(reorderedPictures);
    };

    return (
        <DndContext collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
            <SortableContext items={pictures} strategy={verticalListSortingStrategy}>
                <div className="image-list">
                    {pictures.map((photo) => (
                        <ImagePreview
                            key={photo}
                            id={photo} // Pass the id for drag-and-drop
                            photo={photo}
                            onDelete={() => {
                                const res = pictures.filter((p) => p !== photo);
                                setPictures(res);
                            }}
                        />
                    ))}
                </div>
            </SortableContext>
        </DndContext>
    );
};

export default ImageList;
